module.exports = __webpack_public_path__ + "static/media/bat-face-msg.3595b646.svg";